import { createClient } from '@supabase/supabase-js'

let supabaseUrl  = import.meta.env.VITE_SUPABASE_URL  as string
let supabaseAnon = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl && typeof window !== 'undefined') {
  const host = window.location.hostname
  if (host === 'dev.nujan.pages.dev' || host.includes('staging') || (host.endsWith('nujan.pages.dev') && host !== 'nujan.pages.dev')) {
    supabaseUrl = 'https://doqdprkwemfldhisjolg.supabase.co'
    supabaseAnon = 'sb_publishable_LHe9GRMiw-CFK6eeJUB34Q_PQWhJ14K'
  } else {
    // Production (nujan.app, www.nujan.app, nujan.pages.dev, nujan.com)
    supabaseUrl = 'https://rdsvqzlhamtxzrtshcbb.supabase.co'
    supabaseAnon = 'sb_publishable_-dg8B4_I-lHGsnyOIEimdw_BZeUGmoH'
  }
}

if (!supabaseUrl || !supabaseAnon) {
  console.warn(
    '[Nujan] Supabase credentials not configured.\n' +
    'Copy .env.example -> .env and fill in VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY.\n' +
    'Auth will not work until these are set.'
  )
}

export const supabase = createClient(
  supabaseUrl  || 'http://localhost:54321',
  supabaseAnon || 'placeholder'
)

/** true only when real Supabase credentials are provided */
export const supabaseConfigured = Boolean(supabaseUrl && supabaseAnon)
